import { FC } from "react";

export const Departments: FC = () => {
  return (
    <div className="wrapperv-departments">
      <h2 className="header-list-footer">Departments</h2>
      <ul className="list-footer">
        <li className="item-footer">
          <a href="" className="link-footer">
            Medical
          </a>
        </li>
        <li className="item-footer">
          <a href="" className="link-footer">
            Pharmaceuticals
          </a>
        </li>
        <li className="item-footer">
          <a href="" className="link-footer">
            Medical Equipment
          </a>
        </li>
      </ul>
    </div>
  );
};
